import apiFetch from '../../apiFetch'

export default function (serviceDossierId, servicedossier, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/service/${serviceDossierId}`, method: 'PUT', body: servicedossier, token: token, lastAccessDate })
}
